// 猫眼 i 版
export default {
  appName: 'maoyan_i',
  useKNB: false,
  sellChannel: 5,
  theme: 'maoyan',
  ajaxUrl: '//show.maoyan.com/maoyansh/myshow/ajax',
  ajaxBetaUrl: '//show.test.maoyan.com/maoyansh/myshow/ajax'
};